import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "value", "selectedValue"];
import React from 'react';
import { Box } from '../Box';
import { tabViewDefaultTheme } from './theme';
import { useComponentTheme } from '../../utils/hooks';
import { TabViewRoot } from './style';
import { TAB_VIEW_CLASS_PREFIX } from './constants';
export var TabView = function TabView(_ref) {
  var children = _ref.children,
      value = _ref.value,
      selectedValue = _ref.selectedValue,
      restProps = _objectWithoutProperties(_ref, _excluded);

  if (typeof value === 'undefined' || typeof selectedValue === 'undefined') {
    return null;
  }

  var theme = useComponentTheme(TAB_VIEW_CLASS_PREFIX, tabViewDefaultTheme);
  return value === selectedValue ? React.createElement(TabViewRoot, Object.assign({
    paragraph: true,
    medium: true
  }, restProps, {
    theme: theme
  }), value === selectedValue && React.createElement(Box, {
    padding: 2
  }, children)) : null;
};
TabView.displayName = TAB_VIEW_CLASS_PREFIX;